import type { OrderSelectionValueEntity } from './OrderSelectionValueEntity'

export class SelectionEntity {
  id?: string
  sectionName?: string | null
  values?: Array<OrderSelectionValueEntity> | null
}
